export const ACCESS_USER_TYPE = process.env.REACT_APP_ACCESS_USER_TYPE;
export const API_BASE_URL = process.env.REACT_APP_API_GATEWAY;